import { DetailsProps } from '@features/campaigns/components/CampaignLayout';
import { Header } from './Header';
import { DateFilter } from '../../../components/DateFilter';
import { TabView } from './TabView';
import { AdSpendChip } from './AdSpendChip';

export const Details = (props: DetailsProps) => {
  return (
    <>
      <Header campaignId={props.campaignId} campaignName={props.campaignName} />
      <DateFilter
        campaignId={props.campaignId}
        endReportDates={props.reportDates}
        measurementStartDate={props.campaignStartDate}
        campaignEndDate={props.campaignEndDate}
        channels={props.channels}
      >
        <AdSpendChip />
      </DateFilter>
      <TabView />
    </>
  );
};
